import { getDecimalsAndIntegerLength } from "../helpers";

export const FormsValidator = {

    maxLength: (pageConfig, value, key, forcedMaxLength) => {

        let valid = true;
        if (value.length > 0) {

            valid = (forcedMaxLength ? forcedMaxLength : pageConfig.rules.inputs[key].maxLength.value) >= value.length;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].maxLength.message
        };
    },

    minLength: (pageConfig, value, key, forcedMinLength) => {

        let valid = true;
        if (value.length > 0) {

            valid = (forcedMinLength ? forcedMinLength : pageConfig.rules.inputs[key].minLength.value) <= value.length;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].minLength.message
        };
    },

    maxIntegers: (pageConfig, value, key) => {

        let valid = true;
        if (typeof value === 'number') {

            const { integerLength } = getDecimalsAndIntegerLength(value);
            valid = pageConfig.rules.inputs[key].maxIntegers.value >= integerLength;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].maxIntegers.message
        };
    },

    minIntegers: (pageConfig, value, key) => {

        let valid = true;
        if (typeof value === 'number') {

            const { integerLength } = getDecimalsAndIntegerLength(value);
            valid = pageConfig.rules.inputs[key].minIntegers.value <= integerLength;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].minIntegers.message
        };
    },

    maxDecimals: (pageConfig, value, key) => {

        let valid = true;
        if (typeof value === 'number') {

            const { decimalLength } = getDecimalsAndIntegerLength(value);
            valid = pageConfig.rules.inputs[key].maxDecimals.value >= decimalLength;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].maxDecimals.message
        };
    },

    minDecimals: (pageConfig, value, key) => {

        let valid = true;
        if (typeof value === 'number') {

            const { decimalLength } = getDecimalsAndIntegerLength(value);
            valid = pageConfig.rules.inputs[key].minDecimals.value <= decimalLength;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].minDecimals.message
        };
    },

    min: (pageConfig, value, key, forcedMin) => {
        let valid = true;
        if (value) {

            valid = (forcedMin ? forcedMin : pageConfig.rules.inputs[key].min.value) <= value;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].min.message
        };
    },

    max: (pageConfig, value, key, forcedMax) => {

        let valid = true;
        if (value) {

            valid = (forcedMax ? forcedMax : pageConfig.rules.inputs[key].max.value) >= value;
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].max.message
        };
    },

    pattern: (pageConfig, value, key) => {

        let valid = true;
        if (value) {

            const expreg = new RegExp(pageConfig.rules.inputs[key].pattern.value);
            valid = expreg.test(value);
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].pattern.message
        };
    },

    required: (pageConfig, value, key) => {

        let valid = true;
        if (value && pageConfig.rules.inputs[key].required) {

            valid = value !== undefined && value !== null && (!value?.length || value?.length > 0);
        }

        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].required.message
        };
    },

    compareTo: (value1, value2, pageConfig, key) => {

        const valid = value1 === value2;
        return {
            key,
            valid,
            message: valid ? null : pageConfig.rules.inputs[key].compareTo.message
        };
    },

    /**
     * Devuelve un sumario de las validaciones con su respectivos mensajes
     * @param {* functionList: array con las funciones de validación }
     */
    summary: (functionList) => {

        const validation = [];
        functionList.forEach(func => {

            const result = func();
            validation.push({

                key: result.key,
                message: result.message,
                valid: result.valid
            });
        });

        validation['formValid'] = validation.find(v => !v.valid) === undefined;

        return validation;
    }
};